export class Report {
  type: string = "";
  schemaName: string = "";
  errorMessage: string = "";
  location: string = "";
  flag: string = "";
  isValid: boolean = false;
  ruleId: string = "";
  context: string = "";
  ruleType: string = "";
  schematron: string = "";
  rule: string = "";
  source: string = "";
  reference: string = "";
  suggestion: string = "";
  featureIdentifier: string = "";
  isOldReport: boolean = false;

  constructor(init?: Partial<Report>) {
    Object.assign(this, init);
  }

  static parse(data: any): Report {
    return new Report({
      type: data.type ?? "",
      schemaName: data.schemaName ?? "",
      errorMessage: data.errorMessage ?? "",
      location: data.location ?? "",
      flag: data.flag ?? "",
      isValid: data.valid ?? false,
      ruleId: data["rule-id"] ?? "",
      context: data.context ?? "",
      ruleType: data["rule-type"] ?? "",
      schematron: data.schematron ?? "",
      rule: data.rule ?? "",
      source: data.source ?? "",
      reference: data.reference ?? "",
      suggestion: data.suggestion ?? "",
      featureIdentifier: data["feature-identifier"] ?? "",
      isOldReport: data.severity === undefined, // or any other condition
    });
  }
}
